import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { HrDevelopmentRoutingModule } from './hr-development-routing.module';
import { HrDevelopmentListComponent } from './hr-development-list/hr-development-list.component';
import { HrDevelopmentCreateComponent } from './hr-development-create/hr-development-create.component';

@NgModule({
  declarations: [HrDevelopmentListComponent, HrDevelopmentCreateComponent],
  imports: [
    CommonModule,
    HrDevelopmentRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class HrDevelopmentModule { }
